module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pricing-costs-page",
    class: {
      'pricing-costs-page--settings': _vm.inSettingsHub
    },
    attrs: {
      "id": "prodSettBG"
    }
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.inSettingsHub ? 'Bulk COGS & Margins' : 'Pricing & Costs'))]), _vm._v(" "), (!_vm.inSettingsHub) ? _c('button', {
    staticClass: "back-button",
    on: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  }), _vm._v(" Back\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('DefaultMarginTargetSection', {
    attrs: {
      "settings": _vm.settings,
      "formula-description": _vm.formulaDescription,
      "formula-example": _vm.formulaExample
    },
    on: {
      "margin-change": _vm.onMarginChange,
      "toggle-change": _vm.onToggleChange
    }
  }), _vm._v(" "), _c('BulkImportSection', {
    attrs: {
      "statistics": _vm.statistics,
      "downloading": _vm.downloading,
      "uploading": _vm.uploading
    },
    on: {
      "download-template": _vm.downloadCSVTemplate,
      "file-selected": _vm.handleFileSelected,
      "file-removed": _vm.handleFileRemoved,
      "error": _vm.handleError
    }
  }), _vm._v(" "), (_vm.successMessage) ? _c('div', {
    staticClass: "ui success message"
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": function($event) {
        _vm.successMessage = ''
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Success")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.successMessage))])]) : _vm._e(), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "ui error message"
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": function($event) {
        _vm.errorMessage = ''
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Error")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "page-footer"
  }, [_c('button', {
    staticClass: "cancel-button",
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "save-button",
    class: {
      loading: _vm.saving
    },
    on: {
      "click": _vm.saveSettings
    }
  }, [_vm._v("\n      Save Changes\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6edd8d49!./~/vue-loader/lib/selector.js?type=template&index=0!./src/PricingCostsPage.vue
// module id = 790
// module chunks = 2